import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=6ebc26d9&"
import script from "./setup.js?vue&type=script&lang=javascript&"
export * from "./setup.js?vue&type=script&lang=javascript&"
import style0 from "./DetailPage.vue?vue&type=style&index=0&id=6ebc26d9&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports